import React, { useState } from "react";
import "./index.scss"; // Assurez-vous que le fichier CSS est bien lié

import AppButton from "../appButton";
import Slider from "react-slick"; // Assurez-vous que le fichier CSS est bien lié
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slide1 from "../../assets/slide1.png";
import Slide2 from "../../assets/slide2.png";
import { useNavigate } from "react-router-dom";
const SliderR = () => {
  const navigate = useNavigate();
  const slides = [
    { id: 1, image: Slide1, alt: "Flag 1" },
    { id: 2, image: Slide2, alt: "Flag 2" },
    { id: 3, image: Slide1, alt: "Flag 3" },
  ];
  const [currentIndex, setCurrentIndex] = useState(0);

  const goToNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
  };

  const goToPrev = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + slides.length) % slides.length
    );
  };

  return (
    <section className="section-container-s ">
      {/* Div en haut avec les titres */}
      <div className="top-content-s">
        <div>
          <h3 className="small-title-s">JM Foundation</h3>
          <h1 className="big-title-s">Nous avons besoin de vous !</h1>
        </div>
      </div>
      <div className="image-slider">
        {/* Flèche gauche */}
        <button className="arrow prev-arrow" onClick={goToPrev}>
          &#8249;
        </button>

        {/* Image affichée */}
        <div className="image-container">
          <img
            src={slides[currentIndex].image}
            alt={slides[currentIndex].alt}
          />
        </div>

        {/* Flèche droite */}
        <button className="arrow next-arrow" onClick={goToNext}>
          &#8250;
        </button>
      </div>

      <div className="btn-container">
        <AppButton
          text="CONTACTEZ-NOUS"
          className="width_mobile"
          color="bleu"
          size="large"
          onClick={() => {
            navigate("/contact");    window.scrollTo(0, 0);
          }}
        />
        <AppButton
          text="Faire un don"
          className="width_mobile width-total1"
          color="orange"
          size="large"
          onClick={() => {
            navigate("/faire-don");    window.scrollTo(0, 0);
          }}
        />
      </div>
    </section>
  );
};

export default SliderR;
